import { Component, Input } from '@angular/core';

@Component({
  selector: 'toolbar',
  templateUrl: 'toolbar.html'
})
export class ToolbarComponent {

  @Input () titol: string;

  constructor() {}

  ionViewWillEnter(){

  }

}



// WEBPACK FOOTER //
// ./src/components/toolbar/toolbar.ts